import { DatePicker } from 'antd'
import type { Dayjs } from 'dayjs'
import dayjs from 'dayjs'
import type { FC } from 'react'
import type { DatePickerSchema } from '../schemas'
import { addUtcOffset, minusUtcOffset } from '../utils'

interface UnixDatePickerProps extends Pick<DatePickerSchema, 'showTime' | 'showNow' | 'showWeek' | 'utc'> {
  value?: number
  onChange?: (value?: number) => void
}

const UnixDatePicker: FC<UnixDatePickerProps> = props => {
  const { value, onChange, utc, ...rest } = props

  const internelValue =
    typeof value === 'number' ? (utc ? minusUtcOffset(dayjs(value * 1000)) : dayjs(value * 1000)) : null

  const onChangeHandler = (date: Dayjs) => {
    onChange?.(utc ? addUtcOffset(date).unix() : date.unix())
  }

  return <DatePicker {...rest} value={internelValue} onChange={onChangeHandler} />
}

export default UnixDatePicker
